import { Routes, Route } from "react-router-dom";
import Home from "./Home";
import Intaglio from "./Intaglio";
import Compressione from "./Compressione";
import TraveTrave from "./TraveTrave";
import AncoraggioBase from "./AncoraggioBase";
import GiuntoRipristino from "./GiuntoRipristino"
import StaffaT from "./StaffaT";
import RinforzoTrave from "./RinforzoTrave";
import FissaggioCoibente from "./FissaggioCoibente"
import SolaioCollaborante from "./SolaioCollaborante"
import Revit from "./Revit"

function MainContent() {
    return (
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="Intaglio" element={<Intaglio />} />
          <Route path="Compressione" element={<Compressione />} />
          <Route path="TraveTrave" element={<TraveTrave />} />
          <Route path="AncoraggioBase" element={<AncoraggioBase />} />
          <Route path="GiuntoRipristino" element={<GiuntoRipristino />} />
          <Route path="StaffaT" element={<StaffaT />} />
          <Route path="RinforzoTrave" element={<RinforzoTrave />} />
          <Route path="FissaggioCoibente" element={<FissaggioCoibente />} />
          <Route path="Revit" element={<Revit />} />
          {/* <Route path="SolaioCollaborante" element={<SolaioCollaborante />} /> */}
        </Routes>
      </div>
    );
  }
  export default MainContent;